// 首頁作用域的彈窗白名單與路徑判定（純函式，無 Nuxt runtime 依賴）
//
// 彈窗狀態存在 Pinia 且 renderer 常駐於 layouts/default.vue，本身不具路由生命週期。
// 從 /guest 帶著公告（systemModal）跳回首頁時彈窗會繼續渲染，故需在路由層界定作用域。
import { normalizeBasePath } from '@/utils/urlModal'

// 首頁作用域：三者共用 components/IndexOriginal.vue，對使用者是同一個畫面
const INDEX_SCOPE_PATHS = ['/', '/login', '/register']

// 首頁允許保留的通用彈窗（store.modal）；errorModal 另行保留，不在此列
export const INDEX_ALLOWED_MODALS = [
  // 登入／註冊面板與其延伸流程
  'ModalPanelLogin',
  'ModalPanelSignUp',
  'ModalPasswordForget',
  'ModalPrivacy',
  // 登入／註冊成功後的強制驗證流程：layouts/default.vue 的 watch(authState) 於
  // case 'login' 呼叫 verify('REGISTER', true)，未通過不導頁，窗就開在首頁上
  'ModalSuspensionWarning',
  'ModalVerify',
  'ModalBindBank',
]

export const isIndexScope = (path, locales = []) => INDEX_SCOPE_PATHS.includes(normalizeBasePath(path, locales))
